import { format } from 'date-fns'

export const pathify = (s: string) => s?.toLowerCase().normalize('NFD')
    .replace(/\p{Diacritic}/gu, '')
    .replace(/\s((le|la|les|a|aux|un|une|de|du|et)\s)+/g, ' ')
    .replace(/\s(l|d)('|’)/g, ' ')
    .replace(/[^a-z0-9]/gmi, ' ')
    .replace(/\s+/g, '-')

export const formatDate = (d?: Date | string | null) => d ? format(d, 'dd/MM/yyyy') : ''

export const formatMoney = (d?: number) => d?.toLocaleString('fr-FR', {
    currency: 'EUR',
    style: 'currency',
    roundingMode: "halfCeil"
} as Intl.NumberFormatOptions).replace(',00','') ?? ''

export const formatDuration = (duration: number) => {
    const hours = Math.floor(duration);
    const minutes = Math.round((duration - hours) * 60);

    return minutes === 0
        ? `${hours} h`
        : `${hours} h ${minutes.toString().padStart(2, '0')}`;
}

export const formatVille = (ville: string) => {
    return ville.toLowerCase().replace(/(^|[\s\-])\S/g, letter => letter.toUpperCase())
}

export const htmlToString = (html?: string, length = 160) => {
    return truncate(html?.replace(/<[^>]+>/g, '') ?? '', length)
}

export const truncate = (text?: string, length = 160) => {
    let s = (text ?? '').trim()
    if (s.length <= length)
        return text

    s = s.substr(0, length - 1)
    const tokens = s.split(/\s\S*$/g)
    if (tokens.length > 0)
        s = tokens[0]

    return s + "&hellip;"
}
